import App from 'app/app.js';
import 'app/service/EventService.js';

function LogoutSuccessAction(EventService) {
  this.eventName = 'logoutSuccess';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('LogoutSuccessAction', ['EventService', LogoutSuccessAction]);
